import React from 'react';

/**
 * Skeleton placeholder for the schedule selector row (REST-first Suspense fallback).
 * Supports light and dark mode via theme classes.
 */
export function ScheduleSelectorSkeleton() {
  return (
    <div
      className="flex flex-wrap gap-2 p-2 md:p-3 c7-app-bg border-b border-[var(--c7-border-color)]"
      aria-hidden
    >
      {[1, 2, 3, 4].map((i) => (
        <div
          key={i}
          className="h-9 w-24 md:w-28 rounded-full animate-pulse bg-[var(--c7-muted)] opacity-70"
        />
      ))}
    </div>
  );
}
